var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 64,
      height: 64,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "132.928,277.919 173.562,318.553 255.992,236.123 338.438,318.553 379.072,277.919 255.992,154.839  ",
    style: {
      fill: "rgb(2, 101, 214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.992,0C114.606,0.015,0.015,114.606,0,256.008C0.015,397.394,114.606,511.984,255.992,512 C397.394,511.984,511.985,397.394,512,256.008C511.985,114.606,397.394,0.015,255.992,0z M408.585,408.585 c-39.118,39.079-92.938,63.189-152.593,63.205c-59.647-0.016-113.467-24.126-152.577-63.205 c-39.087-39.111-63.197-92.93-63.205-152.577c0.008-59.655,24.118-113.483,63.205-152.593 c39.11-39.087,92.93-63.197,152.577-63.205c59.655,0.008,113.476,24.118,152.593,63.205c39.079,39.11,63.197,92.938,63.205,152.593 C471.782,315.655,447.672,369.474,408.585,408.585z",
    style: {
      fill: "rgb(2, 101, 214)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.4aeb1afc3d4bd23158aab7dcbccac513.svg";
export { ForwardRef as ReactComponent };